import type { ReactNode } from 'react';
import { type StyleProp, StyleSheet, type ViewStyle } from 'react-native';
import { FadeIn } from '../../../components/animations';
import { Card } from '../../../components/primitives/Card';
import { VStack } from '../../../components/primitives/Stack';
import { Text } from '../../../components/primitives/Text';
import { colors } from '../../../theme/colors';
import { darkPrecisionTypography } from '../../../theme/typography';

interface SettingsSectionProps {
  title: string;
  preamble?: string;
  description?: string;
  children: ReactNode;
  delay?: number;
  boxStyle?: StyleProp<ViewStyle>;
}

export function SettingsSection({
  title,
  preamble,
  description,
  children,
  delay = 100,
  boxStyle,
}: Readonly<SettingsSectionProps>) {
  return (
    <FadeIn delay={delay}>
      <Card variant="default" padding="xl" radius="xl" style={boxStyle}>
        <VStack spacing="xl">
          <VStack spacing="xxs">
            {preamble ? (
              <Text style={[darkPrecisionTypography.label, styles.preamble]}>{preamble}</Text>
            ) : null}
            <Text
              style={[darkPrecisionTypography.heading, styles.title]}
              color={colors.text.primary}
            >
              {title}
            </Text>
            {description ? (
              <Text variant="body" color={colors.text.secondary} style={styles.description}>
                {description}
              </Text>
            ) : null}
          </VStack>
          {children}
        </VStack>
      </Card>
    </FadeIn>
  );
}

const styles = StyleSheet.create({
  title: {
    color: colors.text.primary,
  },
  preamble: {
    color: colors.text.tertiary,
  },
  description: {
    marginTop: 4,
  },
});
